import React, { useState, useCallback } from 'react';

import { Col, Container, Row } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';

import {
  Card,
  CardHeader,
  CardBody,
} from '../../../pages/CartaoSaudeDetalhe/styles';
import { IParcelas } from '../../../pages/CartaoSaudeDetalhe';
import ItemManutencao from './ItemManutencao';

type ComponentProps = {
  parcelas: IParcelas[];
};

const Manutencao: React.FC<ComponentProps> = ({ parcelas }) => {
  const [parcelasManutencao, setParcelasManutencao] = useState<
    IParcelas[] | undefined
  >(parcelas);

  const handleAlteraExcluida = useCallback((cprCodigo: number) => {
    setParcelasManutencao(state => {
      if (state) {
        const indexParcela = state.findIndex(p => p.CprCodigo === cprCodigo);
        if (!indexParcela) return state;
        return state.map((p, index) => {
          if (index === indexParcela)
            return { ...p, CprExcluida: !p.CprExcluida };
          return p;
        });
      }
      return [];
    });
  }, []);

  return (
    <Container className="p-1" style={{ height: '100%', minHeight: '300px' }}>
      {parcelasManutencao && parcelasManutencao.length > 0 && (
        <Row noGutters>
          <Col>
            <Card style={{ height: '578px' }}>
              <CardHeader>
                <span>
                  <FaUser size={15} /> <b>PARCELAS</b>
                </span>

                {/* {clinica.ConfigBoleto?.Emite && (
                  <ButtonAdd
                    type="button"
                    onClick={() => handleGeraBoletos()}
                    title="gerar Boletos"
                  >
                    <FaBarcode size={15} /> Gerar Boletos
                  </ButtonAdd>
                )} */}
              </CardHeader>

              <CardBody>
                {/* <Table
                  className="text-secondary"
                  style={{ marginBottom: '9px' }}
                  hover
                  size="sm"
                > */}
                <Row noGutters className="bg-light text-dark pt-1 pb-2 pl-1">
                  <Col md={1} className="px-1">
                    ID
                  </Col>
                  <Col md={2} className="px-1">
                    Parcelas
                  </Col>
                  <Col md={1} className="px-1">
                    Pago
                  </Col>
                  <Col md={1} className="px-1">
                    Ativa
                  </Col>
                  <Col md={1} className="px-1">
                    Excluída
                  </Col>
                  <Col md={2} className="px-1">
                    Data
                  </Col>
                  <Col md={2} className="px-1">
                    Valor
                  </Col>
                  <Col md={2} className="px-1">
                    -
                  </Col>
                </Row>
                {parcelasManutencao?.map(parc => (
                  <ItemManutencao
                    handleAlteraExcluida={handleAlteraExcluida}
                    parcela={parc}
                  />
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default Manutencao;
